import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';
export default class LogoWithSlider {
    constructor() {
        this.section = document.querySelector('.block-logo-with-slider');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });
    }
}

if (document.querySelector('.block-logo-with-slider')) {
    new LogoWithSlider();
}
